<template>
  <div class="onReg">
    <div class="g-box">
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-width="70px"
        class="onReg-form"
      >
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="form.phone"></el-input>
        </el-form-item>
        <div class="onReg-form-btn m-h" @click="onSubmit">提交报名</div>
      </el-form>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../mixins/pageMain_mx";
import { Form, FormItem, Input, Message } from "element-ui";

export default {
  mixins: [pageMain_mx],
  data() {
    return {
      form: {
        name: "",
        phone: "",
        channel: "运营营销",
        address: "http://www.huabote.com/"
      },
      rules: {
        name: [{ required: true, message: "请填写姓名", trigger: "blur" }],
        phone: [
          { required: true, validator: this.$fun.form.phone, trigger: "blur" }
        ]
      }
    };
  },
  components: {
    "el-form": Form,
    "el-form-item": FormItem,
    "el-input": Input
  },
  mounted() {},
  methods: {
    onSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.$api.ums.promote.backgroundMessage_messageForClient
            .post(this.form)
            .then(() => {
              Message.success("提交成功，请耐心等待老师与您联系");
              this.$refs["form"].resetFields();
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>
<style lang="less">
.onReg {
  padding: 110px 0;
}
.onReg-form {
  width: 650px;
  border: 1px solid rgba(225, 225, 225, 1);
  margin: 0 auto;
  padding: 66px 80px;
  box-sizing: border-box;
}
.onReg-form-btn {
  width: 320px;
  height: 42px;
  line-height: 42px;
  text-align: center;
  background: rgba(82, 151, 224, 1);
  border-radius: 4px;
  color: #ffffff;
  font-size: 16px;
  margin: 70px auto 0 auto;
}
</style>
